module.exports = __webpack_public_path__ + "dist/assets/img/P.faf90205.svg";